/** Reads the first usable message out of a problem-details style `errors` array. */
export function extractApiErrorDetail(data: unknown): string | null {
   if (!data || typeof data !== "object") return null;
   const {errors} = data as {errors?: unknown};
   if (!Array.isArray(errors)) return null;
   for (const error of errors) {
      // The body is unvalidated, so `detail` can be any type or missing entirely.
      const detail =
         typeof error === "string" ? error : (error as {detail?: unknown} | null)?.detail;
      if (typeof detail === "string" && detail.trim()) return detail.trim();
   }
   return null;
}
